// Use relative imports to avoid dependency cycles

import { capitalizeString } from '../capitalizeString';
import { shouldMakeUpperCase } from '../shouldMakeUpperCase';

const capitalizeWords = (words: string): string => 
  // Split by word boundaries and process each word
  words.split(/\s+/).map(word => {
    if (shouldMakeUpperCase(word)) {
      return word.toUpperCase();
    }
    return capitalizeString(word);
  }).join(' ');

export default capitalizeWords;
